import { render, staticRenderFns } from "./device-changing.component.vue?vue&type=template&id=3f8e8e86"
import script from "./device-changing.component.ts?vue&type=script&lang=ts&external"
export * from "./device-changing.component.ts?vue&type=script&lang=ts&external"
import style0 from "./device-changing.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports